import { AnimationEvent, usePopup, ConditionalRender } from '@libs/core';
import { TBottomSheetProps, TModalWindow } from '@libs/types';
import clsx from 'clsx';
import React from 'react';
import Dash from '../Dash';
import styles from './bottomSheet.module.css';

type TClassicBottomSheetProps = {
    widgetId?: string;
    animatedClose: boolean;
    modal: React.ReactNode | null;
    bottomSheet?: TModalWindow;
    setAnimatedClose: React.Dispatch<React.SetStateAction<boolean>>;
    closeAnimationPopup: (e: AnimationEvent<HTMLDivElement>) => void;
    WidgetsList: TBottomSheetProps['WidgetsList'];
};

const ClassicBottomSheet = ({ bottomSheet, modal, widgetId, animatedClose, setAnimatedClose, closeAnimationPopup, WidgetsList }: TClassicBottomSheetProps) => {
    const hasCurrentBottomSheet = bottomSheet && bottomSheet?.uid?.length > 0;
    const { handlers, overlayRef, overlayClick, dashClick } = usePopup(widgetId && hasCurrentBottomSheet, setAnimatedClose, modal);
    const isComplexBottomSheet = hasCurrentBottomSheet && bottomSheet?.uid?.length > 1;
    const bottomSheetContentUid = isComplexBottomSheet ? [bottomSheet?.uid?.[0]] : bottomSheet?.uid;

    return (
        <div id="bottom-sheet" {...handlers}>
            <div className={styles.overlay} onClick={overlayClick}>
                <div className={styles.popupOuter}>
                    <div className={clsx(styles.popupBox, animatedClose && styles.closeAnimationName)} onAnimationEnd={closeAnimationPopup} ref={overlayRef}>
                        <div className={styles.popupBoxContentWrapper}>
                            <Dash onTouchEnd={dashClick} />
                            <div className={styles.popupBoxContent}>
                                <WidgetsList uids={bottomSheetContentUid} />
                            </div>
                        </div>
                        <ConditionalRender condition={isComplexBottomSheet}>
                            {bottomSheet?.uid?.slice(1).map((uid) => (
                                <div key={uid} className={styles.popupBoxButtons}>
                                    <WidgetsList key={uid} uids={[uid]} />
                                </div>
                            ))}
                        </ConditionalRender>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default ClassicBottomSheet;
